<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading…</div>
    <div v-if="loaded" class="root">
      <div class="blob blob-a" aria-hidden="true"></div>
      <div class="blob blob-b" aria-hidden="true"></div>
      <nav class="nav">
        <div class="nav-left">
          <img :src="lightLogoUrl" class="nav-logo" />
        </div>
        <div class="nav-center">
          <span class="nav-lo">{{ loName || "Loan Officer" }}</span>
          <span class="nav-leaf">🌿</span>
          <span class="nav-re">{{ realtorName || "Realtor" }}</span>
        </div>
   
      </nav>
      <section class="hero">
        <div class="hero-text">
       
          <h1 class="hero-h1" v-html="heroH1Html"></h1>
          <p class="hero-body">{{ heroBody }}</p>
          <div class="hero-btns">
            <a class="btn-earth" :href="applyRightLink">{{ heroPrimaryText }}</a>
            <a v-if="applyLeftLink" class="btn-ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
          </div>
          <div class="hero-quick">
            <a v-if="loinfo && loinfo.phone_number" class="hq-link" :href="'tel:' + loinfo.phone_number">Call us</a>
            <span class="hq-dot">·</span>
            <a v-if="loinfo && loinfo.email" class="hq-link" :href="'mailto:' + loinfo.email">Email us</a>
            <span v-if="realtor && realtor.website_url" class="hq-dot">·</span>
            <a v-if="realtor && realtor.website_url" class="hq-link" :href="realtor.website_url" target="_blank" rel="noreferrer">Partner site</a>
          </div>
        </div>
      </section>
      <section class="profiles">
        <div class="grove-card lo-grove">
          <div class="gc-img-area">
            <div class="gc-img-bg"></div>
            <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="gc-img" />
          </div>
          <div class="gc-content">
            <span class="gc-tag">Loan Officer</span>
            <div class="gc-name">{{ loName }}</div>
            <div class="gc-role">{{ loTitle }}</div>
            <div v-if="loinfo && loinfo.nmls" class="gc-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
            <div class="gc-divider"></div>
            <div class="gc-contacts">
              <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="gc-link">{{ loinfo.phone_number }}</a>
              <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="gc-link">{{ loinfo.email }}</a>
            </div>
       
          </div>
        </div>
        <div class="grove-card re-grove">
          <div class="gc-img-area re-img-area">
            <div class="gc-img-bg re-bg"></div>
            <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="gc-img" />
          </div>
          <div class="gc-content">
            <span class="gc-tag re-gc-tag">{{ realtor?.partner_title || 'Partner' }}</span>
            <div class="gc-name">{{ realtorName }}</div>
            <div class="gc-role">{{ realtor && realtor.brokerage_name ? realtor.brokerage_name : "" }}</div>
            <div v-if="realtor && realtor.nmls" class="gc-nmls">NMLS {{ (realtor.nmls || "").trim() }}</div>
            <div class="gc-divider re-divider"></div>
            <div class="gc-contacts">
              <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="gc-link re-gc-link">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="gc-link re-gc-link">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="gc-link re-gc-link" target="_blank" rel="noreferrer">Website →</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending:        { primary: "#eb610a", accent: "#646363" },
  radiantmortgage:    { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage:     { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam:         { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage:         { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage:     { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial:  { primary: "#0b1726", accent: "#c69c39" },
};
const DBA_BASE = "https://api.goldstarfinancial.com/DBA";
function dbaLogo(brandKey, variant = "primary") { return `${DBA_BASE}/${brandKey}/${variant}.png`; }
function getBrandKey(email) {
  if (!email) return null;
  const d = email.slice(email.indexOf("@") + 1).toLowerCase();
  return d.split(".")[0] || null;
}
export default {
  name: "CoBrandGrove",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    lightLogoUrl() { return dbaLogo(this.brandKey, "primary"); },
    
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) {
        const a = parts[0].trim();
        const b = parts.slice(1).join(",").trim();
        return `${a}<br/><em>${b}</em>`;
      }
      return h;
    },
    
    heroHeading() { return this.loinfo?.text_section_heading || "About"; },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      const p = [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim();
      return p || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Nunito:wght@300;400;500;600&display=swap');

.page {
  min-height: 100vh;
  background: #f2f5ef;
  color: #1e2418;
  font-family: 'Nunito', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --sage: #7a9a6e;
  --moss: #4a6741;
  --bg: #f2f5ef;
  --card-bg: #fafdf8;
  --hairline: rgba(30,36,24,0.10);
  --muted: #6b7a5e;
  --a-tint: color-mix(in srgb, var(--a) 12%, #f2f5ef);
  --sage-tint: color-mix(in srgb, var(--sage) 18%, #f2f5ef);
  position: relative; overflow-x: hidden;
}
.root { position: relative; z-index: 1; display: flex; flex-direction: column; min-height: 100vh; }

.blob { position: fixed; border-radius: 999px; pointer-events: none; z-index: 0; filter: blur(80px); }
.blob-a { width: 500px; height: 400px; background: color-mix(in srgb, var(--sage) 35%, #f2f5ef); top: -100px; right: -100px; border-radius: 60% 40% 70% 30% / 50% 60% 40% 50%; opacity: 0.6; }
.blob-b { width: 350px; height: 300px; background: color-mix(in srgb, var(--a) 20%, #f2f5ef); bottom: 80px; left: -80px; border-radius: 40% 60% 30% 70% / 60% 40% 60% 40%; opacity: 0.5; }

.nav { position: relative; z-index: 10; display: flex; align-items: center; justify-content: space-between; padding: 22px 48px; background: rgba(242,245,239,0.85); backdrop-filter: blur(16px); border-bottom: 1px solid var(--hairline); }
.nav-logo { width: 160px; max-height:80px; object-fit: contain; }
.nav-center { display: flex; align-items: center; gap: 10px; font-size: 13px; }
.nav-lo { font-weight: 600; color: var(--p); }
.nav-leaf { font-size: 16px; }
.nav-re { color: var(--muted); }
.nav-cta { font-size: 13px; font-weight: 600; text-decoration: none; background: var(--moss); color: #fff; padding: 10px 22px; border-radius: 50px; transition: opacity 0.2s, transform 0.2s; }
.nav-cta:hover { opacity: 0.88; transform: translateY(-1px); }

.hero { position: relative; z-index: 1; padding: 42px 48px 56px; max-width: 760px; margin:auto }
.hero-kicker { display: block; font-size: 11px; font-weight: 600; letter-spacing: 0.22em; text-transform: uppercase; color: var(--sage); margin-bottom: 16px; }
.hero-h1 { font-family: 'Playfair Display', serif; font-size: clamp(40px, 5.5vw, 70px); font-weight: 700; line-height: 1.08; color: var(--p); margin: 0 0 20px; }
.hero-h1 em { font-style: italic; color: var(--moss); font-weight: 400; }
.hero-body { font-size: 15px; line-height: 1.78; color: var(--muted);  margin-bottom: 28px; font-weight: 300; }
.hero-btns { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 20px; justify-content: center;}
.btn-earth { width:55%;font-size: 14px; font-weight: 600; text-decoration: none; background: var(--p); color: #fff; padding: 13px 28px; border-radius: 50px; box-shadow: 0 4px 18px color-mix(in srgb, var(--p) 22%, transparent); transition: transform 0.18s; }
.btn-earth:hover { transform: translateY(-1px); }
.btn-ghost { font-size: 14px; font-weight: 500; text-decoration: none; color: var(--p); background: rgba(255,255,255,0.7); border: 1.5px solid var(--hairline); padding: 13px 28px; border-radius: 50px; backdrop-filter: blur(8px); transition: background 0.18s; }
.btn-ghost:hover { background: rgba(255,255,255,0.9); }
.hero-quick { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.hq-link { font-size: 13px; text-decoration: none; color: var(--muted); border-bottom: 1px solid var(--hairline); padding-bottom: 1px; transition: color 0.18s; }
.hq-link:hover { color: var(--moss); }
.hq-dot { color: var(--hairline); }

.profiles { position: relative; z-index: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 0 48px 64px; }
.grove-card { background: var(--card-bg); border-radius: 28px; overflow: hidden; border: 1px solid var(--hairline); box-shadow: 0 8px 36px rgba(30,36,24,0.08); transition: transform 0.22s, box-shadow 0.22s; }
.grove-card:hover { transform: translateY(-4px); box-shadow: 0 16px 50px rgba(30,36,24,0.13); }
.gc-img-area { height: 110px; position: relative; overflow: hidden; background: var(--sage-tint); }
.re-img-area { background: var(--a-tint); }
.gc-img-bg { position: absolute; inset: 0; background: radial-gradient(ellipse at 80% 20%, color-mix(in srgb, var(--sage) 35%, transparent), transparent 60%); }
.re-bg { background: radial-gradient(ellipse at 80% 20%, color-mix(in srgb, var(--a) 30%, transparent), transparent 60%); }
.gc-img { position: absolute; bottom: -20px; left: 22px; width: 80px; border-radius: 18px; object-fit: cover; border: 3px solid var(--card-bg); box-shadow: 0 4px 18px rgba(30,36,24,0.15); }
.gc-content { padding: 28px 22px 22px; }
.gc-tag { font-size: 9px; font-weight: 700; letter-spacing: 0.22em; text-transform: uppercase; color: var(--sage); display: block; margin-bottom: 8px; }
.re-gc-tag { color: color-mix(in srgb, var(--a) 75%, #8b6f47); }
.gc-name { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 700; color: var(--p); margin-bottom: 3px; }
.gc-role { font-size: 12px; color: var(--muted); margin-bottom: 2px; }
.gc-nmls { font-size: 11px; color: color-mix(in srgb, var(--muted) 60%, transparent); margin-bottom: 14px; }
.gc-divider { height: 1px; background: var(--hairline); margin: 14px 0; }
.re-divider { background: linear-gradient(90deg, color-mix(in srgb, var(--a) 40%, transparent), transparent); }
.gc-contacts { display: flex; flex-direction: column; gap: 5px; margin-bottom: 16px; }
.gc-link { font-size: 12px; text-decoration: none; color: var(--muted); transition: color 0.18s; }
.gc-link:hover { color: var(--moss); }
.re-gc-link:hover { color: color-mix(in srgb, var(--a) 80%, #8b6f47); }
.gc-cta { display: block; text-align: center; text-decoration: none; background: var(--p); color: #fff; font-size: 13px; font-weight: 600; padding: 11px; border-radius: 14px; transition: opacity 0.18s; }
.gc-cta:hover { opacity: 0.85; }

@media (max-width: 720px) {
  .profiles { grid-template-columns: 1fr; padding: 0 24px 48px; }
  .hero { padding: 48px 24px 40px; }
  .nav { padding: 16px 24px; }
  .nav-center { display: none; }
}
</style>
